import { NavLink, Outlet } from 'react-router-dom';
import { LayoutGrid, List, Calendar } from 'lucide-react';
import { SectionHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/production/board',    label: 'Shop Floor', icon: LayoutGrid },
  { to: '/production/tickets',  label: 'All Tickets', icon: List },
  { to: '/production/schedule', label: 'Schedule',   icon: Calendar },
];

export function ProductionLayout() {
  return (
    <div className="space-y-8">
      <SectionHeader
        kicker="Production · Shop Floor"
        title="Work in motion."
        description="Tickets routed through stations — panel, door, finish, QC, ship. Real-time status from every workstation."
      />

      <div className="border-b border-border overflow-x-auto -mx-8 px-8">
        <nav className="flex gap-1 -mb-px">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'inline-flex items-center gap-2.5 px-5 h-11 text-xs uppercase tracking-[0.15em] transition-colors border-b-2 whitespace-nowrap',
                    isActive
                      ? 'border-brass-400 text-text'
                      : 'border-transparent text-text-muted hover:text-text',
                  )
                }
              >
                <Icon size={13} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div><Outlet /></div>
    </div>
  );
}
